<template>
  <nav class="menu" ref="modal">
    <button class="menu__button" :aria-label="$t('general.cta.closeMenu')" @click="$emit('setMenuOpen')">
      <icon
        class="menu__button__icon"
        :data="pageIcons[content.iconClose]"
        height="1.125rem"
        width="1.125rem"
      ></icon>
    </button>
    <LanguageSwitcher
      v-if="mobile"
      :content="languageContent"
      class="menu__lang"
    />
    <ul class="menu-list">
      <ModalMenuItem
        v-for="(item, index) in content.navItems"
        :key="'list-item-' + index"
        :item="item"
        @setMenuOpen="$emit('setMenuOpen')"
      />
    </ul>
  </nav>
</template>

<script setup>
import { pageIcons } from "../../plugins/page-icons.js";
import ModalMenuItem from "./ModalMenuItem.vue";
import { computed, ref } from "@vue/reactivity";
import { inject } from "vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import { onClickOutside } from "@vueuse/core";

defineProps({
  content: Object,
  languageContent: Object,
});
const modal = ref("modal");
const emit = defineEmits(["setMenuOpen"]);

const tvaMq = inject("$tvaMq");
const mobile = computed(() => tvaMq.value === "mobile");

onClickOutside(modal, () => emit("setMenuOpen"));
</script>

<style lang="scss" scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  height: calc(var(--vh, 1vh) * 100);
  width: toRem(466);
  border-radius: 0px toRem(35) toRem(35) 0px;
  background-color: $scala-grigi-white;
  padding: 0 toRem(47) 0 toRem(50);
  @include bottom-shadow-timeline;

  &__button {
    min-height: toRem(50);
    min-width: toRem(50);
    transform: translateX(-17px);
    margin-top: toRem(13);
    float: left;
  }

  &-list {
    margin-top: toRem(95);
  }
}

.tablet,
.mobile {
  .menu {
    width: 100%;
    border-radius: 0;
    padding: 0 toRem(39);

    &__button {
      @include bottom-shadow-timeline;
      border-radius: 100%;
      margin: 0;
      transform: none;
    }
  }
}

.mobile {
  .menu {
    padding: 0 toRem(27);

    &__lang {
      float: right;
      margin-top: toRem(15);
    }
  }
}
</style>
